

import React from 'react';
import Break from '../../components/Break';
import JobCard from '../../components/Cards/JobCard';
import Consolas from '../../fonts/Consolas';
import { H1 } from '../../helper/constants';
import { fulltime, infosys, internships } from './helper';
const Experience = (): JSX.Element =>
(
    <div className='Experience'>
        <Consolas align='center' as={H1}>Full Time</Consolas>
        {
            fulltime.map((job, i) =>
                <JobCard
                    key={i}
                    company={job.company}
                    start={job.start}
                    end={job.end}
                    title={job.title}
                    description={job.description} 
                    tools={job.tools}/>)
        }
        <Break/>
        <Consolas align='center' as={H1}>Clients Through Infosys</Consolas>
        {
            infosys.map((job, i) =>
                <JobCard
                    key={i}
                    company={job.company}
                    start={job.start}
                    end={job.end}
                    title={job.title}
                    description={job.description} 
                    tools={job.tools}/>)
        }
        <Break/>
        <Consolas align='center' as={H1}>Internships</Consolas>
        {
            internships.map((job, i) =>
                <JobCard
                    key={i}
                    company={job.company}
                    start={job.start}
                    end={job.end}
                    title={job.title}
                    description={job.description} 
                    tools={job.tools}/>)
        }

    </div>
)

export default Experience;
